import React, { useState, useEffect, useCallback } from "react";
import { withTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { PendingActionsRow } from "./PendingActionsRow";
import dashboardStyles from "../dealerDashBoard/dashboardStyles";
import styles from "../dealerDashBoard/DashboardStyles.module.scss";
import PendingActionClient from "../../../shared/clients/PendingActionClient";
import { IS_CANADA_MARKET } from "../../../utils/EmpUtil";

function PendingActions(props) {
  const [pendingActions, setPendingActions] = useState([]);

  const sortByDate = useCallback((pendingActionsData) => {
    if (!pendingActionsData || !Array.isArray(pendingActionsData)) {
      return [];
    }
    const sortedActions = [...pendingActionsData].sort(function (a, b) {
      const itemA = new Date(a.dueDate.split("/").reverse());
      const itemB = new Date(b.dueDate.split("/").reverse());
      return itemA - itemB;
    });
    return sortedActions;
  }, []);

  const getPendingActions = useCallback(async () => {
    if (typeof props.hideOrShow === "function") {
      try {
        props.hideOrShow(true, true);
      } catch (err) {
        console.error("[PendingActions] Exception calling hideOrShow(true):", err);
      }
    }

    try {
      if (props.isNsc) {
        return await PendingActionClient.getNscPendingActionsNotifications(props.user);
      } else {
        const data = await PendingActionClient.getDealerPendingActionsNotifications(props.user, false);
        return data;
      }
    } catch {
      if (props.user && props.user.pendingActions) {
        return { pendingActions: props.user.pendingActions };
      }
      return { pendingActions: [] };
    }
  }, [props.hideOrShow, props.isNsc, props.user]);

  useEffect(() => {
    getPendingActions()
      .then((data) => {
        const actionsArray = data.pendingActions || [];
        const sortedActions = sortByDate(actionsArray);
        setPendingActions(sortedActions);
      })
      .catch((error) => {
        console.error("[PendingActions] Error in useEffect:", error);
        setPendingActions([]);
      })
      .finally(() => {
        if (typeof props.hideOrShow === "function") {
          try {
            props.hideOrShow(false);
          } catch (err) {
            console.error("[PendingActions] Exception calling hideOrShow(false):", err);
          }
        }
      });
  }, [props.user, props.isNsc, getPendingActions, sortByDate]);

  return (
    <>
      <div
        style={dashboardStyles.header}
        className={styles.pendingActionsHeader}
      >
        {IS_CANADA_MARKET(props.user?.market)
          ? props.t("DealerDashboard.admin")
          : props.t("DealerDashboard.adminAndPrice")}
        <span data-testid="pendingActionsCount">
          {" "}
          ({pendingActions.length})
        </span>
      </div>
      <Table data-testid="actionsTable" key="actionsTable">
        <PendingActionHeader t={props.t} />
        <TableBody>
          {pendingActions.map((pendingAction, index) => {
            if (
              pendingAction.attributes &&
              pendingAction.attributes["vehicleLines"]
            ) {
              return pendingAction.attributes["vehicleLines"].map(
                (vehicleLine, vehicleIndex) => {
                  return PendingActionsRow(
                    pendingAction,
                    index + "-" + vehicleIndex,
                    props,
                    vehicleLine
                  );
                }
              );
            } else {
              return PendingActionsRow(pendingAction, index, props);
            }
          })}
        </TableBody>
      </Table>
    </>
  );
}

const PendingActionHeader = (props) => {
  return (
    <TableHead>
      <TableRow
        style={dashboardStyles.dashboardHeader}
        className={styles.tableHeaderLine}
      >
        <TableCell style={dashboardStyles.typeHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.type")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.orderIdHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.description")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.dateHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.dueDate")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.actionHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.action")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.emptyHeader} />
      </TableRow>
    </TableHead>
  );
};

export default withTranslation("emp")(PendingActions);
